import React, { useState, useEffect } from 'react';
import { Box, Typography, Modal, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import RestoreIcon from '@mui/icons-material/Restore';
import axios from 'axios';

const DeletedCliches360 = ({ open, onClose }) => {
    const [deletedCliches, setDeletedCliches] = useState([]);
    const [selectedCliche, setSelectedCliche] = useState(null);


    const apiBaseURL = 'https://plasticemployers.duckdns.org';      // IP da rede local

    const fetchDeletedCliches = async () => {
        try {
            const response = await axios.get(`${apiBaseURL}/api/cliches360imprimireliminados/`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            });
            setDeletedCliches(response.data);
        } catch (error) {
            console.error('Erro ao buscar clichês eliminados:', error);
        }
    };

    useEffect(() => {
        if (open) {
            fetchDeletedCliches();
        }
    }, [open]);

    const handleDeletePermanently = async (clicheId) => {
        try {
            await axios.delete(`${apiBaseURL}/api/cliches360imprimireliminados/${clicheId}/`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            });
            setDeletedCliches((prevCliches) => prevCliches.filter((cliche) => cliche.id !== clicheId));
        } catch (error) {
            console.error('Erro ao eliminar permanentemente o clichê:', error);
        }
    };

    const handleRestoreCliche = async (cliche) => {
        try {
            const formData = new FormData();
            formData.append('nome_trabalho', cliche.nome_trabalho);
            formData.append('plano', cliche.plano);
            formData.append('tamanho', cliche.tamanho);
            formData.append('numero_cliche', cliche.numero_cliche);
            formData.append('tipo_trabalho', cliche.tipo_trabalho);
            if (cliche.foto) {
                const response = await fetch(cliche.foto);
                const blob = await response.blob();
                formData.append('foto', blob, 'restored-image.png');
            }

            await axios.post(`${apiBaseURL}/api/cliches360imprimir/`, formData, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                    'Content-Type': 'multipart/form-data',
                },
            });

            // Remove do estado de eliminados após restaurar
            setDeletedCliches((prevCliches) => prevCliches.filter((item) => item.id !== cliche.id));
        } catch (error) {
            console.error('Erro ao restaurar o clichê:', error);
        }
    };

    const handleOpenDetails = (cliche) => {
        setSelectedCliche(cliche);
    };

    const handleCloseDetails = () => {
        setSelectedCliche(null);
    };

    return (
        <Modal open={open} onClose={onClose}>
        <Box 
            sx={{ 
                p: 4, 
                backgroundColor: 'white', 
                width: '90%', 
                maxWidth: 800, 
                margin: 'auto', 
                mt: '5%', 
                borderRadius: 2, 
                maxHeight: '80vh',  // Define a altura máxima da modal
                overflowY: 'auto',   // Scroll vertical
                overflowX: 'auto',   // Scroll horizontal
            }}
        >
                <Typography variant="h5" gutterBottom>Clichês Eliminados</Typography>

                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Nome do Trabalho</TableCell>
                                <TableCell>Número do Clichê</TableCell>
                                <TableCell>Tipo de Trabalho</TableCell>
                                <TableCell>Tamanho</TableCell>
                                <TableCell>Eliminado Por</TableCell>
                                <TableCell>Data de Eliminação</TableCell>
                                <TableCell>Ações</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {deletedCliches.map((cliche) => (
                                <TableRow key={cliche.id}>
                                    <TableCell>{cliche.nome_trabalho}</TableCell>
                                    <TableCell>{cliche.numero_cliche}</TableCell>
                                    <TableCell>{cliche.tipo_trabalho}</TableCell>
                                    <TableCell>{cliche.tamanho}</TableCell>
                                    <TableCell>{cliche.eliminado_por?.username || 'Desconhecido'}</TableCell>
                                    <TableCell>{new Date(cliche.data_eliminacao).toLocaleString()}</TableCell>
                                    <TableCell>
                                        <IconButton color="primary" onClick={() => handleRestoreCliche(cliche)}>
                                            <RestoreIcon />
                                        </IconButton>
                                        <IconButton color="secondary" onClick={() => handleDeletePermanently(cliche.id)}>
                                            <DeleteIcon />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

                {/* Modal para visualizar detalhes de um clichê eliminado */}
                {selectedCliche && (
                    <Modal open={Boolean(selectedCliche)} onClose={handleCloseDetails}>
                        <Box sx={{ p: 4, backgroundColor: 'white', width: '90%', maxWidth: 500, margin: 'auto', mt: '10%', borderRadius: 3 }}>
                            <Typography variant="h4" gutterBottom color="primary">
                                {selectedCliche.nome_trabalho}
                            </Typography>
                            <Typography variant="body1">Número do Clichê: {selectedCliche.numero_cliche}</Typography>
                            <Typography variant="body1">Tamanho: {selectedCliche.tamanho}</Typography>
                            <Typography variant="body1">Tipo de Trabalho: {selectedCliche.tipo_trabalho}</Typography>
                            <Typography variant="body1">Plano: {selectedCliche.plano}</Typography>

                            {selectedCliche.foto ? (
                                <Box sx={{ my: 2, borderRadius: 2, overflow: 'hidden' }}>
                                    <img src={selectedCliche.foto} alt={selectedCliche.nome_trabalho} style={{ width: '100%', borderRadius: '8px' }} />
                                </Box>
                            ) : (
                                <Typography sx={{ my: 2, color: 'text.secondary', fontStyle: 'italic' }}>
                                    Imagem não disponível
                                </Typography>
                            )}

                            <Button onClick={handleCloseDetails} variant="contained" color="primary" sx={{ mt: 2 }}>
                                Fechar
                            </Button>
                        </Box>
                    </Modal>
                )}

                <Button onClick={onClose} variant="contained" color="primary" sx={{ mt: 2 }}>
                    Fechar
                </Button>
            </Box>
        </Modal>
    );
};

export default DeletedCliches360;